module.exports = __webpack_public_path__ + "static/media/wordpress-es.59acf5bb.png";